import { grey } from "@mui/material/colors";

export const pdfViewerStyles = {
  bgcolor: grey[400],
};
